import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "prorationSection"]
  static values = { fillOnConnect: { type: Boolean, default: true } }

  connect() {
    this.connected = false
    if (this.fillOnConnectValue) {
      this.update({ target: this.element.querySelector("select") })
    }
    this.connected = true
  }

  update(e) {
    const selectedOption = e.target.selectedOptions[0]
    const selectedOptionData = selectedOption.dataset

    this.inputTarget.value = selectedOptionData.price
    this.inputTarget.classList.add("animate-pulse")
    setTimeout(() => {
      this.inputTarget.classList.remove("animate-pulse")
    })

    if (this.hasProrationSectionTarget) {
      const prorationCheckbox = this.prorationSectionTarget.querySelector("input[type='checkbox']")
      if (selectedOptionData.proration == "true") {
        prorationCheckbox.disabled = false
        this.prorationSectionTarget.dataset.controller = ""
      } else {
        prorationCheckbox.checked = false
        prorationCheckbox.disabled = true
        this.prorationSectionTarget.dataset.controller = "popover"
      }
    }

    if (this.connected) {
      this.#reloadDiscounts(selectedOption.value)
    }
  }

  #reloadDiscounts(billingIntervalId) {
    const turboFrame = this.element.querySelector("turbo-frame#discounts_section")
    if (!turboFrame) return

    const pathParts = window.location.pathname.split("/")
    pathParts.pop()
    pathParts.push("discounts.turbo_stream")
    const pathName = pathParts.join("/")

    const params = new URLSearchParams(window.location.search)
    params.append("billing_interval_id", billingIntervalId)
    const selectedDiscount = turboFrame.querySelector("input[name='create_lease[discount_id]'][type='radio']:checked")
    params.append("discount_id", selectedDiscount?.value)

    turboFrame.src = `${window.location.origin}${pathName}?${params.toString()}`
  }
}
